import { ElementTypes } from '../element-types';

export class Confirmation {
  private static readonly prefix: string = 'confirmation';
  static readonly MainContent: string = `${Confirmation.prefix}-${ElementTypes.Div}-main-content`;
  static readonly ConfirmationSection: string = `${Confirmation.prefix}-${ElementTypes.Div}-section`;
  static readonly PdsLink: string = `${Confirmation.prefix}-${ElementTypes.Link}-pds`;
  static readonly IpidLink: string = `${Confirmation.prefix}-${ElementTypes.Link}-ipid`;
  static readonly NibTermsLink: string = `${Confirmation.prefix}-${ElementTypes.Link}-nib-terms`;
  static readonly ClientTermsLink: string = `${Confirmation.prefix}-${ElementTypes.Link}-client-terms`;
  static readonly PolicyNumber: string = `${Confirmation.prefix}-${ElementTypes.Paragraph}-policy-number`;
}
